const notifications = [
    {
        "date": "2022-03-15T00:00:00.000+08",
        "appNo": "202100012",
        "subject": "需現場補件",
        "content": "請於20221/1/15內補齊應檢附文件與費用，若於當天檢核尚未完成，將依據「有機農產品驗證機構與農產品經營者簽訂契約應記載事項」" +
            "貳、三、(三)「因可歸責申請人之事由致書面審查後六個月內無法進行實地稽核」則駁回驗證申請。"
    }
]

export default notifications